module.exports = __webpack_public_path__ + "static/FL2-3e8a2477f6c923c0e58e5d04c9e76b90.jpg";